import {
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6,
  ELEMENT_PARAGRAPH,
  MARK_BOLD,
  MARK_ITALIC,
  MARK_UNDERLINE,
  MARK_STRIKETHROUGH,
  ELEMENT_HR,
  ELEMENT_LINK,
  ELEMENT_UL,
  ELEMENT_OL,
  ELEMENT_LI,
  ELEMENT_TODO_LI,
  ELEMENT_MEDIA_EMBED,
  ELEMENT_TABLE,
  ELEMENT_TR,
  ELEMENT_TD,
  ELEMENT_TH,
  ELEMENT_IMAGE,
  MARK_FONT_FAMILY,
  MARK_FONT_SIZE,
  MARK_FONT_WEIGHT,
  MARK_BG_COLOR,
  MARK_COLOR,
} from '@udecode/plate';
import { PlateLeaf } from '@udecode/plate-common';
import { withProps } from '@udecode/cn';

import { withPlaceholders } from './components/placeholder/placeholder';
import { HeadingElement } from './plugins/heading/HeadingElement';
import { ParagraphElement } from './plugins/paragraph/ParagraphElement';
import { MarkElement } from './components/elements/MarkElement';
import { ListElement } from './plugins/list/ListElement';
import { TodoListElement } from './plugins/todo-list/ToDoListElement';
import { TableElement } from './plugins/table/TableElement';
import { TableRowElement } from './plugins/table/TableRowElement';
import { TableCellElement } from './plugins/table/TableCellElement';
import { ELEMENT_PAGE_BREAK } from './plugins/page-break/createPageBreakPlugin';
import { PageBreakElement } from './plugins/page-break/PageBreakElement';
import { ImageElement2 } from './plugins/media/images/ImageElement2';
import { MediaEmbedElement2 } from './plugins/media/Media2';
import { ListItemElement } from './plugins/list/ListItemElement';
import { LinkElement } from './plugins/link/LinkElement';
import { NOTE_HEADER, NOTE_HEADER_VOID } from './plugins/layout/note-layout/createNoteLayoutPlugin';
import { NoteHeaderElement } from './plugins/layout/note-layout/NoteHeaderElement';
import { ELEMENT_MERGE_FIELD, ELEMENT_SMART_INPUT } from './plugins/merge-fields/createMergeFieldsPlugin';
import { MergeFieldElement } from './plugins/merge-fields/MergeFieldElement';
import { SmartInputElement } from './plugins/merge-fields/SmartInputElement';
import { HrElement } from './plugins/hr/HrElement';

export const plateUI = (overrideByKey, { /* draggable, */ placeholder } = {}) => {
  let components = {
    [MARK_BOLD]: withProps(PlateLeaf, { as: 'strong' }),
    [MARK_ITALIC]: withProps(PlateLeaf, { as: 'em' }),
    [MARK_UNDERLINE]: withProps(PlateLeaf, { as: 'u' }),
    [MARK_STRIKETHROUGH]: withProps(PlateLeaf, { as: 's' }),
    [ELEMENT_H1]: withProps(HeadingElement, { as: 'h1' }),
    [ELEMENT_H2]: withProps(HeadingElement, { as: 'h2' }),
    [ELEMENT_H3]: withProps(HeadingElement, { as: 'h3' }),
    [ELEMENT_H4]: withProps(HeadingElement, { as: 'h4' }),
    [ELEMENT_H5]: withProps(HeadingElement, { as: 'h5' }),
    [ELEMENT_H6]: withProps(HeadingElement, { as: 'h6' }),
    [ELEMENT_PARAGRAPH]: withProps(ParagraphElement, { as: 'p' }),
    [ELEMENT_HR]: HrElement,
    [ELEMENT_LINK]: LinkElement,
    [ELEMENT_OL]: withProps(ListElement, { as: 'ol' }),
    [ELEMENT_UL]: withProps(ListElement, { as: 'ul' }),
    [ELEMENT_LI]: ListItemElement,
    [ELEMENT_TODO_LI]: TodoListElement,
    [ELEMENT_IMAGE]: ImageElement2,
    [ELEMENT_MEDIA_EMBED]: withProps(MediaEmbedElement2, {
      caption: { disabled: true },
    }),
    [ELEMENT_TABLE]: TableElement,
    [ELEMENT_TR]: TableRowElement,
    [ELEMENT_TD]: TableCellElement,
    [ELEMENT_TH]: TableCellElement,
    [ELEMENT_PAGE_BREAK]: PageBreakElement,
    [NOTE_HEADER]: NoteHeaderElement,
    [NOTE_HEADER_VOID]: NoteHeaderElement,
    [ELEMENT_MERGE_FIELD]: MergeFieldElement,
    [ELEMENT_SMART_INPUT]: SmartInputElement,
  };

  if (overrideByKey) {
    Object.keys(overrideByKey).forEach((key) => {
      components[key] = overrideByKey[key];
    });
  }
  if (placeholder) {
    components = withPlaceholders(components);
  }
  /* #TODO: Implement draggable
  if (draggable) {
    components = withDraggables(components);
  }
  */

  return components;
};

export const serializePlateUI = (overrideByKey, { /* draggable, */ placeholder } = {}) => {
  let components = {
    [ELEMENT_H1]: withProps(HeadingElement, { as: 'h1' }),
    [ELEMENT_H2]: withProps(HeadingElement, { as: 'h2' }),
    [ELEMENT_H3]: withProps(HeadingElement, { as: 'h3' }),
    [ELEMENT_H4]: withProps(HeadingElement, { as: 'h4' }),
    [ELEMENT_H5]: withProps(HeadingElement, { as: 'h5' }),
    [ELEMENT_H6]: withProps(HeadingElement, { as: 'h6' }),
    [ELEMENT_PARAGRAPH]: withProps(ParagraphElement, { as: 'p' }),
    [ELEMENT_OL]: withProps(ListElement, { as: 'ol' }),
    [ELEMENT_UL]: withProps(ListElement, { as: 'ul' }),
    [ELEMENT_LINK]: LinkElement,
    [ELEMENT_LI]: ListItemElement,
    [ELEMENT_TODO_LI]: TodoListElement,
    [ELEMENT_IMAGE]: ImageElement2,
    [ELEMENT_MEDIA_EMBED]: withProps(MediaEmbedElement2, {
      caption: { disabled: true },
    }),
    [ELEMENT_TABLE]: TableElement,
    [ELEMENT_TD]: TableCellElement,
    [ELEMENT_TH]: TableCellElement,
    [ELEMENT_PAGE_BREAK]: PageBreakElement,
    [MARK_FONT_FAMILY]: MarkElement,
    [MARK_FONT_SIZE]: MarkElement,
    [MARK_FONT_WEIGHT]: MarkElement,
    [MARK_COLOR]: MarkElement,
    [MARK_BG_COLOR]: MarkElement,
    [NOTE_HEADER]: NoteHeaderElement,
    [NOTE_HEADER_VOID]: NoteHeaderElement,
  };

  if (overrideByKey) {
    Object.keys(overrideByKey).forEach((key) => {
      components[key] = overrideByKey[key];
    });
  }
  if (placeholder) {
    components = withPlaceholders(components);
  }
  /* #TODO: implement draggable.
  if (draggable) {
    components = withDraggables(components);
  }
  */

  return components;
};
